import ResponseStatusMapper from './ReponseStatusMapper';
import FindUnhandledData from './FindUnhandledData';

class PaymentMethodMappedParams {
  acctid: string;
  lastfour: string;
  accttype: string;
  profileid: string;
  expiry: string;
  respstat: string;
  unhandled_params: any;

  constructor(data: any) {
    const handledKeys = [
      'savedPaymentMethodId',
      'lastfour',
      'accountType',
      'payorId',
      'cardExpiry',
      'legacyResponseCode',
      'responseStatus'
    ];

    this.acctid = data.savedPaymentMethodId;
    this.lastfour = data.lastfour;
    this.accttype = data.accountType;
    this.profileid = data.payorId;
    this.expiry = data.cardExpiry;
    this.respstat = data.legacyResponseCode || ResponseStatusMapper(data.responseStatus);
    this.unhandled_params = FindUnhandledData(data, handledKeys);
  }
}

export default PaymentMethodMappedParams;
